// @flow

import { observer } from "mobx-react";
import React from "react";

import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";
import VideoPlayer from "app/components/VideoPlayer/VideoPlayer";
import AppearanceStore from "app/stores/AppearanceStore";

type Props = {
    showPlayerMetadata: boolean,
};

@observer
export default class VideoPlayerContainer extends React.Component<Props> {
    render() {
        const video = VideoStore.video;

        return (
            <VideoPlayer
                source={video.source}
                originalId={video.original_id}
                thumbnail={video.source_thumbnail}
                autoPlay={false}
                volume={VideoPlayerStore.volume}
                onStateChange={VideoPlayerStore.updateState}
                onPlay={VideoPlayerStore.play}
                onProgress={VideoPlayerStore.updateProgress}
                stateDispatcher={VideoPlayerStore.stateDispatcher}
                seekDispatcher={VideoPlayerStore.seekDispatcher}
                onVolumeChange={VideoPlayerStore.setVolume}
                onPause={VideoPlayerStore.pause}                
                customControls={!AppearanceStore.isMobileBrowser && this.props.showPlayerMetadata}
                isMainVideo={true}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoPlayerContainer.js